module.exports = __webpack_public_path__ + "img/client-fangig.3fc73662.png";